import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";

const state = {
    roles: [],
    role: null,
};

const getters = {

};

const mutations = {


}

const getCurrentRoleLevel = () => {
    const roleLevel = localStorage.getItem('roleLevel');
    return roleLevel !== null && roleLevel !== '' ? Number(roleLevel) : null;
};

const normalizeLevel = (level) => {
    if (level === undefined || level === null || level === '') {
        return null;
    }

    return Number(level);
};

const actions = {

    async updateRole({commit}, form) {
        try {
            const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
            const isAdmin = permissions.includes('ADMINISTRATOR');

            const variables = {
                id: form.id,
                roleInput: {
                    name: form.name,
                    listOfPageResourcePermissionId: form.listOfPageResourcePermissionId
                }
            };

            const level = normalizeLevel(form.level);
            if (level !== null) {
                variables.roleInput.level = level;
            } else if (!isAdmin) {
                const roleLevel = getCurrentRoleLevel();
                if (roleLevel !== null) {
                    variables.roleInput.level = roleLevel;
                }
            }

            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation updateRole($id: Int!,$roleInput: RoleInput!) {
                        updateRole(id: $id,roleInput: $roleInput) {
                            id
                            name
                            level
                        }
                    }
                `,
                variables: variables,
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    }
                }
            });

            if(response.errors){
                return false
            }

        } catch (error) {
            console.log(error.message);
            return false;
        }

        return true;
    },
    async createRole({commit}, form) {



        try {
            const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
            const isAdmin = permissions.includes('ADMINISTRATOR');

            const variables = {
                roleInput: {
                    name: form.name,
                    listOfPageResourcePermissionId: form.listOfPageResourcePermissionId,
                }
            };

            const level = normalizeLevel(form.level);
            if (level !== null) {
                variables.roleInput.level = level;
            } else if (!isAdmin) {
                const roleLevel = getCurrentRoleLevel();
                if (roleLevel !== null) {
                    variables.roleInput.level = roleLevel;
                }
            }

            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation createRole($roleInput: RoleInput!) {
                        createRole(roleInput: $roleInput) {
                            id
                            name
                            level
                        }
                    }
                `,
                variables: variables,
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    }
                }
            });

            if(response.errors){
                return false
            }
        } catch (e) {
            console.log("Error", e.stack);
            console.log("Error", e.name);
            console.log("Error", e.message);
            return false;
        }



        return true;
    }

}

export default {
    state,
    getters,
    mutations,
    actions,
};
